module.exports = __webpack_public_path__ + "34bc775d/img/product-icon-grey.b248963c.svg";